// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { focusStyles } from "@toolkit/Themes/common/mixins";

/* Store Custom Code - Start */
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";
/* Store Custom Code - End */

const clickable: Styleguide["clickable"] = {
    defaultProps: {
        css: css`
            ${focusStyles()}

            /* Store Custom Code - Start */
            &:disabled {
                span {
                    color: ${getColor("common.disabled")};
                }
            }
            /* Store Custom Code - End */
        `,
    },
};

export default clickable;
